/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */

import { useCallback, useEffect, useState } from "react"
import { useHotKeyHandler } from "trux"

export const useHotkeys = ({
    showMulticamOnboarding,
    showMulticamTooltip,
    showChurnedDialog,
    play,
    pause,
    toast,
    goToNext,
    goToPrev,
    paused,
    location,
}) => {
    const [respondToHotkeys, setRespondToHotkeys] = useState(true)

    // Monitor severable variables, including "url"/location changes, and determine
    // whether we're on a route in which the hotkeys should be disabled
    // Monitor "url"/location changes and determine whether we're on a route
    // in which the hotkeys should be disabled
    useEffect(() => {
        const disableHotkeysBasedOnDialogs =
            showMulticamOnboarding || showMulticamTooltip || showChurnedDialog
        const disableHotkeysBasedOnLocation =
            location?.pathname &&
            (location.pathname.includes("edit-moment") ||
                location.pathname.includes("create-moment") ||
                location.pathname.includes("personalize") ||
                location.pathname.includes("save-moment"))
        if (disableHotkeysBasedOnDialogs || disableHotkeysBasedOnLocation) {
            setRespondToHotkeys(false)
        } else if (
            !disableHotkeysBasedOnLocation &&
            !disableHotkeysBasedOnLocation
        ) {
            setRespondToHotkeys(true)
        }
    }, [
        showMulticamOnboarding,
        showMulticamTooltip,
        showChurnedDialog,
        location,
    ])

    /// HOTKEYS
    useHotKeyHandler(
        [" "],
        useCallback(() => {
            if (!respondToHotkeys) return
            if (paused) {
                play()
                toast("Play")
            } else {
                pause()
                toast("Pause")
            }
        }, [paused, play, pause, respondToHotkeys])
    )

    useHotKeyHandler(
        ["ArrowLeft"],
        useCallback(() => {
            if (!respondToHotkeys) return
            goToPrev()
            toast("Previous")
        }, [goToPrev, respondToHotkeys])
    )

    useHotKeyHandler(
        ["ArrowRight"],
        useCallback(() => {
            if (!respondToHotkeys) return
            goToNext()
            toast("Next")
        }, [goToNext, respondToHotkeys])
    )
}
